import { put, all, call } from "redux-saga/effects";

import axios from "../../services/axios-service";
import * as actions from "../actions";
import ConsoleLog from "../../hoc/ConsoleLog/ConsoleLog";
import getS3ImageUrl from "../../lib/s3FileHandler";
/**
 * @desc saga for talentpool
 * @version
 * @author Lakshmikanth
 * @return api response
 */
export function* getTalentPoolsSaga(action) {
  try {
    const jobTitleId =
      localStorage.getItem("jobTitleId") &&
      localStorage.getItem("jobTitleId") !== "" &&
      localStorage.getItem("jobTitleId") !== "null"
        ? localStorage.getItem("jobTitleId")
        : action.jobTitleId;
    const response = yield axios.get(
      "/galaxy/job/" + jobTitleId + "/candidate?isClientList=1"
    );
    const isClient = true;
    if (response.data && response.data.items && !response.data.items.message) {
      for (let i = 0; i < response.data.items.length; i++) {
        if (response.data.items[i].candidate_image) {
          const responseImage = yield call(
            getS3ImageUrl,
            response.data.items[i].candidate_image,
            action.user
          );
          response.data.items[i].s3SignedUrl = responseImage;
        }
      }
      yield put(actions.setTalentPool(response.data.items, isClient));
    } else {
      let resp = [];
      resp[0] = { message: "no data" };
      yield put(actions.setTalentPool(resp, isClient));
    }
  } catch (error) {
    ConsoleLog("check error", error);
  }
}

export function* getTalentPoolsRecruiterSaga(action) {
  try {
    const response = yield axios.get(
      "/galaxy/job/" + action.jobTitleId + "/candidate"
    );
    const isClient = false;
    if (response.data && response.data.items && !response.data.items.message) {
      let dataArray = response.data.items;
      let candidateId =
        dataArray.filter(candidate => candidate.published === 0).length > 0
          ? dataArray.filter(candidate => candidate.published === 0)[0]
              .candidate_id
          : dataArray[0].candidate_id;
      let permitteddata = {};
      if (response.data.permitteddata.permitteduseremail !== null) {
        permitteddata = response.data.permitteddata;
      }
      dataArray["permittedcontactdata"] = permitteddata;
      for (let i = 0; i < dataArray.length; i++) {
        if (dataArray[i].candidate_image) {
          const responseImage = yield call(
            getS3ImageUrl,
            dataArray[i].candidate_image,
            action.user
          );
          dataArray[i].s3SignedUrl = responseImage;
        }
      }

      //yield put(actions.updateProfileImage(action.userImageUrl, response));
      yield put(actions.setTalentPool(dataArray, isClient));
      const candidateResponse = yield axios.get(
        "/galaxy/job/" + action.jobTitleId + "/candidate/" + candidateId
      );
      if (candidateResponse.data.item.candidate_image) {
        const candidateImageResponse = yield call(
          getS3ImageUrl,
          candidateResponse.data.item.candidate_image,
          action.user
        );
        candidateResponse.data.item.s3SignedUrl = candidateImageResponse;
      }

      yield put(actions.setCandidateProfile(candidateResponse.data.item));
    } else {
      let resp = [];
      resp[0] = { message: "no data" };
      yield put(actions.setTalentPool(resp, isClient));
    }
  } catch (error) {
    ConsoleLog(error);
  }
}

export function* viewCandidateRecruiterSaga(action) {
  const candidateResponse = yield axios.get(
    "/galaxy/job/" + action.jobTitleId + "/candidate/" + action.candidateId
  );
  if (candidateResponse.data.item.candidate_image) {
    const candidateImageResponse = yield call(
      getS3ImageUrl,
      candidateResponse.data.item.candidate_image,
      action.user
    );
    candidateResponse.data.item.s3SignedUrl = candidateImageResponse;
  }
  yield put(actions.setCandidateProfile(candidateResponse.data.item));
}



// WEBPACK FOOTER //
// ./src/store/sagas/talentPool.js